import { TRoomsParams } from 'common/types/floor-params.type';

export const getIsShowRooms = ({
  calculatedRooms,
  isFloorCalculatorId,
}: {
  calculatedRooms: TRoomsParams[];
  isFloorCalculatorId: boolean;
}) => calculatedRooms.length > 0 && isFloorCalculatorId;
